import React,{useState,useEffect} from 'react'
import { useAuth } from '../../context/AuthContext'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { AccountBalance, AccountCircle, Announcement, BookOnline, Business,Menu, CalendarMonthOutlined, Campaign, Category, Chat, Dashboard, DataObject, DoorSliding, Dvr, FollowTheSigns, Groups3, Home,  Label,  ListAlt,  ManageAccounts, MenuOpen, MoreVert, Newspaper, NoteAdd, Notifications, PhoneAndroid, PsychologyAlt, Quiz, ReplyAll, Settings, Store, Tablet, TransferWithinAStation, Tv, WorkOutlined} from '@mui/icons-material';
import useBusinessInfo from '../../hooks/useBusinessInfo';
import { Alert, } from '@mui/material';
import moment from 'moment';
import { useAppData } from '../../context/AppDataContext';

function AdminHeader() {

    const {toolbarStatus,setToolbarStatus} = useAppData();
    const {authUser } = useAuth();
    const businessInfo = useBusinessInfo();

    const navigate = useNavigate();
    useEffect(()=>{
        if(businessInfo?.accountStatus === false){
          navigate("/admin/suspend-page");
        }
    },[businessInfo])

    return (
        <>
        {businessInfo?.pendingDays < 15 &&
            <div className="">
                <div className='text-danger text-center'> Your Account will suspend on { moment(businessInfo.validTill).format("ll")} please recharge asap</div>
            </div>
        }
        <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow mb-3">
            <div className="container-fluid">
                <Link className="me-5" to="/">
                    <img src='/globalinc.png' style={{height:40}} />
                    {/* <img className="ms-2" src='/images/whatsapp.png' style={{height:40}} /> */}
                </Link> {/* navbar-brand  */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    { authUser.role <= 2 && 
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{fontSize:"18px"}}>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/"> <Home/> Home</NavLink></li>
                        
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"><Business/> SCM</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/product/dashboard">Manage Product</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/vendor/dashboard">Manage Vendor</NavLink></li>
                                <li><hr className="dropdown-divider"/></li>
                                <li><NavLink className="dropdown-item" to="/po/dashboard"> Manage PO</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/inventory/dashboard">Manage Inventory</NavLink></li>
                                <li><hr className="dropdown-divider"/></li>
                            </ul>
                        </li>


                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown"><Groups3/> CRM</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/customer/dashboard">Manage Customer</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/grievance/dashboard">Grievance</NavLink></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown"><AccountBalance/> Accounts</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/transaction/dashboard">Transections</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/transaction/list">Transections List</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/transaction/item-list">Transections Item List</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/transaction-category/dashboard">Transections Category</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/tender/dashboard">Manage Tender</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/invoice/dashboard">Manage Invoice</NavLink></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown"><Category/> Projects</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/company/dashboard">Manage Company</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/project/dashboard">Manage Projects</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/task/dashboard">Manage Task</NavLink></li>
                                
                                <li><NavLink className="dropdown-item" to="/project-location/dashboard">Manage Projects Locations</NavLink></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown"><Category/> HRMS</NavLink>
                            <ul className="dropdown-menu">
                                
                                <li><NavLink className="dropdown-item" to="/employee/dashboard">Manage Employee</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/attendance/dashboard">Attendance</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/leave-request/dashboard">Leave Request</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/work-report/dashboard">Work Report</NavLink></li>
                                {/* <li><NavLink className="dropdown-item" to="/holiday-list/dashboard">Holiday List</NavLink></li> */}
                                <li><NavLink className="dropdown-item" to="/employee/print-id-card">Print ID Card</NavLink></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="/barcode" role="button" data-bs-toggle="dropdown"><ListAlt/>Documents</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/document/dashboard"> Documents</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/barcode/search">Barcode Scan</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/barcode/manager">Barcode Manager</NavLink></li>
                            </ul>
                        </li>
                    </ul>
                    }
                    {/* Just for Alignment  */}
                    { authUser.role > 2 &&
                        <div className=" me-auto "></div>
                    } 
                    <div className=" ">
                        <button className='btn btn-outline-primary' onClick={()=>(setToolbarStatus(!toolbarStatus))} > {toolbarStatus ? <MenuOpen/>: <Menu/>} </button>
                    </div>

                        <ul className="navbar-nav">
                            { authUser.role <= 2 && 
                            <li className="nav-item dropdown">
                                <a className="nav-link" href="!#" id="adminControllDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <MoreVert/> </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="adminControllDropdown">
                                    <li><NavLink className="dropdown-item" to="/master/list"><Label /> Status Master</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/business/details"><WorkOutlined/> Business Details</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/list"><ManageAccounts/> Manage User Accounts</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/role"><Settings/> Manage User Role</NavLink></li>
                                </ul>
                            </li>
                            }



                            <li className="nav-item dropdown">
                                <a className="btn btn-danger" style={{borderRadius:"50px"}} href="!#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> 
                                    {authUser.firstName.charAt(0).toUpperCase()}
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                                    {/*<li><a className="dropdown-item" href="/auth/change-password">Change Password</a></li> */}
                                    <li><hr className="dropdown-divider"/></li>
                                    <li><NavLink className="dropdown-item" to="/auth/logout">Logout</NavLink></li>
                                </ul>
                            </li>
                        </ul>
                </div>
            </div>
        </nav>
        </>
    )
}

export default AdminHeader